class CountryISOCode {
  constructor(
    readonly alpha2Code: string,
    readonly alpha3Code: string,
    readonly numeric: string
  ) {}

  static fromCode(code: string): CountryISOCode | undefined {
    const index = countryISOCodes.findIndex(
      (countryISOCode) =>
        countryISOCode.alpha2Code === code ||
        countryISOCode.alpha3Code === code ||
        countryISOCode.numeric === code
    )

    if (index >= 0) {
      return countryISOCodes[index]
    }
    return undefined
  }

  static allCodes(): CountryISOCode[] {
    return countryISOCodes
  }
}

const countryISOCodes = [
  new CountryISOCode('AF', 'AFG', '004'),
  new CountryISOCode('AX', 'ALA', '248'),
  new CountryISOCode('AL', 'ALB', '008'),
  new CountryISOCode('DZ', 'DZA', '012'),
  new CountryISOCode('AS', 'ASM', '016'),
  new CountryISOCode('AD', 'AND', '020'),
  new CountryISOCode('AO', 'AGO', '024'),
  new CountryISOCode('AI', 'AIA', '660'),
  new CountryISOCode('AQ', 'ATA', '010'),
  new CountryISOCode('AG', 'ATG', '028'),
  new CountryISOCode('AR', 'ARG', '032'),
  new CountryISOCode('AM', 'ARM', '051'),
  new CountryISOCode('AW', 'ABW', '533'),
  new CountryISOCode('AU', 'AUS', '036'),
  new CountryISOCode('AT', 'AUT', '040'),
  new CountryISOCode('AZ', 'AZE', '031'),
  new CountryISOCode('BS', 'BHS', '044'),
  new CountryISOCode('BH', 'BHR', '048'),
  new CountryISOCode('BD', 'BGD', '050'),
  new CountryISOCode('BB', 'BRB', '052'),
  new CountryISOCode('BY', 'BLR', '112'),
  new CountryISOCode('BE', 'BEL', '056'),
  new CountryISOCode('BZ', 'BLZ', '084'),
  new CountryISOCode('BJ', 'BEN', '204'),
  new CountryISOCode('BM', 'BMU', '060'),
  new CountryISOCode('BT', 'BTN', '064'),
  new CountryISOCode('BO', 'BOL', '068'),
  new CountryISOCode('BQ', 'BES', '535'),
  new CountryISOCode('BA', 'BIH', '070'),
  new CountryISOCode('BW', 'BWA', '072'),
  new CountryISOCode('BV', 'BVT', '074'),
  new CountryISOCode('BR', 'BRA', '076'),
  new CountryISOCode('IO', 'IOT', '086'),
  new CountryISOCode('BN', 'BRN', '096'),
  new CountryISOCode('BG', 'BGR', '100'),
  new CountryISOCode('BF', 'BFA', '854'),
  new CountryISOCode('BI', 'BDI', '108'),
  new CountryISOCode('CV', 'CPV', '132'),
  new CountryISOCode('KH', 'KHM', '116'),
  new CountryISOCode('CM', 'CMR', '120'),
  new CountryISOCode('CA', 'CAN', '124'),
  new CountryISOCode('KY', 'CYM', '136'),
  new CountryISOCode('CF', 'CAF', '140'),
  new CountryISOCode('TD', 'TCD', '148'),
  new CountryISOCode('CL', 'CHL', '152'),
  new CountryISOCode('CN', 'CHN', '156'),
  new CountryISOCode('CX', 'CXR', '162'),
  new CountryISOCode('CC', 'CCK', '166'),
  new CountryISOCode('CO', 'COL', '170'),
  new CountryISOCode('KM', 'COM', '174'),
  new CountryISOCode('CD', 'COD', '180'),
  new CountryISOCode('CG', 'COG', '178'),
  new CountryISOCode('CK', 'COK', '184'),
  new CountryISOCode('CR', 'CRI', '188'),
  new CountryISOCode('CI', 'CIV', '384'),
  new CountryISOCode('HR', 'HRV', '191'),
  new CountryISOCode('CU', 'CUB', '192'),
  new CountryISOCode('CW', 'CUW', '531'),
  new CountryISOCode('CY', 'CYP', '196'),
  new CountryISOCode('CZ', 'CZE', '203'),
  new CountryISOCode('DK', 'DNK', '208'),
  new CountryISOCode('DJ', 'DJI', '262'),
  new CountryISOCode('DM', 'DMA', '212'),
  new CountryISOCode('DO', 'DOM', '214'),
  new CountryISOCode('EC', 'ECU', '218'),
  new CountryISOCode('EG', 'EGY', '818'),
  new CountryISOCode('SV', 'SLV', '222'),
  new CountryISOCode('GQ', 'GNQ', '226'),
  new CountryISOCode('ER', 'ERI', '232'),
  new CountryISOCode('EE', 'EST', '233'),
  new CountryISOCode('SZ', 'SWZ', '748'),
  new CountryISOCode('ET', 'ETH', '231'),
  new CountryISOCode('FK', 'FLK', '238'),
  new CountryISOCode('FO', 'FRO', '234'),
  new CountryISOCode('FJ', 'FJI', '242'),
  new CountryISOCode('FI', 'FIN', '246'),
  new CountryISOCode('FR', 'FRA', '250'),
  new CountryISOCode('GF', 'GUF', '254'),
  new CountryISOCode('PF', 'PYF', '258'),
  new CountryISOCode('TF', 'ATF', '260'),
  new CountryISOCode('GA', 'GAB', '266'),
  new CountryISOCode('GM', 'GMB', '270'),
  new CountryISOCode('GE', 'GEO', '268'),
  new CountryISOCode('DE', 'DEU', '276'),
  new CountryISOCode('GH', 'GHA', '288'),
  new CountryISOCode('GI', 'GIB', '292'),
  new CountryISOCode('GR', 'GRC', '300'),
  new CountryISOCode('GL', 'GRL', '304'),
  new CountryISOCode('GD', 'GRD', '308'),
  new CountryISOCode('GP', 'GLP', '312'),
  new CountryISOCode('GU', 'GUM', '316'),
  new CountryISOCode('GT', 'GTM', '320'),
  new CountryISOCode('GG', 'GGY', '831'),
  new CountryISOCode('GN', 'GIN', '324'),
  new CountryISOCode('GW', 'GNB', '624'),
  new CountryISOCode('GY', 'GUY', '328'),
  new CountryISOCode('HT', 'HTI', '332'),
  new CountryISOCode('HM', 'HMD', '334'),
  new CountryISOCode('VA', 'VAT', '336'),
  new CountryISOCode('HN', 'HND', '340'),
  new CountryISOCode('HK', 'HKG', '344'),
  new CountryISOCode('HU', 'HUN', '348'),
  new CountryISOCode('IS', 'ISL', '352'),
  new CountryISOCode('IN', 'IND', '356'),
  new CountryISOCode('ID', 'IDN', '360'),
  new CountryISOCode('IR', 'IRN', '364'),
  new CountryISOCode('IQ', 'IRQ', '368'),
  new CountryISOCode('IE', 'IRL', '372'),
  new CountryISOCode('IM', 'IMN', '833'),
  new CountryISOCode('IL', 'ISR', '376'),
  new CountryISOCode('IT', 'ITA', '380'),
  new CountryISOCode('JM', 'JAM', '388'),
  new CountryISOCode('JP', 'JPN', '392'),
  new CountryISOCode('JE', 'JEY', '832'),
  new CountryISOCode('JO', 'JOR', '400'),
  new CountryISOCode('KZ', 'KAZ', '398'),
  new CountryISOCode('KE', 'KEN', '404'),
  new CountryISOCode('KI', 'KIR', '296'),
  new CountryISOCode('KP', 'PRK', '408'),
  new CountryISOCode('KR', 'KOR', '410'),
  new CountryISOCode('KW', 'KWT', '414'),
  new CountryISOCode('KG', 'KGZ', '417'),
  new CountryISOCode('LA', 'LAO', '418'),
  new CountryISOCode('LV', 'LVA', '428'),
  new CountryISOCode('LB', 'LBN', '422'),
  new CountryISOCode('LS', 'LSO', '426'),
  new CountryISOCode('LR', 'LBR', '430'),
  new CountryISOCode('LY', 'LBY', '434'),
  new CountryISOCode('LI', 'LIE', '438'),
  new CountryISOCode('LT', 'LTU', '440'),
  new CountryISOCode('LU', 'LUX', '442'),
  new CountryISOCode('MO', 'MAC', '446'),
  new CountryISOCode('MK', 'MKD', '807'),
  new CountryISOCode('MG', 'MDG', '450'),
  new CountryISOCode('MW', 'MWI', '454'),
  new CountryISOCode('MY', 'MYS', '458'),
  new CountryISOCode('MV', 'MDV', '462'),
  new CountryISOCode('ML', 'MLI', '466'),
  new CountryISOCode('MT', 'MLT', '470'),
  new CountryISOCode('MH', 'MHL', '584'),
  new CountryISOCode('MQ', 'MTQ', '474'),
  new CountryISOCode('MR', 'MRT', '478'),
  new CountryISOCode('MU', 'MUS', '480'),
  new CountryISOCode('YT', 'MYT', '175'),
  new CountryISOCode('MX', 'MEX', '484'),
  new CountryISOCode('FM', 'FSM', '583'),
  new CountryISOCode('MD', 'MDA', '498'),
  new CountryISOCode('MC', 'MCO', '492'),
  new CountryISOCode('MN', 'MNG', '496'),
  new CountryISOCode('ME', 'MNE', '499'),
  new CountryISOCode('MS', 'MSR', '500'),
  new CountryISOCode('MA', 'MAR', '504'),
  new CountryISOCode('MZ', 'MOZ', '508'),
  new CountryISOCode('MM', 'MMR', '104'),
  new CountryISOCode('NA', 'NAM', '516'),
  new CountryISOCode('NR', 'NRU', '520'),
  new CountryISOCode('NP', 'NPL', '524'),
  new CountryISOCode('NL', 'NLD', '528'),
  new CountryISOCode('NC', 'NCL', '540'),
  new CountryISOCode('NZ', 'NZL', '554'),
  new CountryISOCode('NI', 'NIC', '558'),
  new CountryISOCode('NE', 'NER', '562'),
  new CountryISOCode('NG', 'NGA', '566'),
  new CountryISOCode('NU', 'NIU', '570'),
  new CountryISOCode('NF', 'NFK', '574'),
  new CountryISOCode('MP', 'MNP', '580'),
  new CountryISOCode('NO', 'NOR', '578'),
  new CountryISOCode('OM', 'OMN', '512'),
  new CountryISOCode('PK', 'PAK', '586'),
  new CountryISOCode('PW', 'PLW', '585'),
  new CountryISOCode('PS', 'PSE', '275'),
  new CountryISOCode('PA', 'PAN', '591'),
  new CountryISOCode('PG', 'PNG', '598'),
  new CountryISOCode('PY', 'PRY', '600'),
  new CountryISOCode('PE', 'PER', '604'),
  new CountryISOCode('PH', 'PHL', '608'),
  new CountryISOCode('PN', 'PCN', '612'),
  new CountryISOCode('PL', 'POL', '616'),
  new CountryISOCode('PT', 'PRT', '620'),
  new CountryISOCode('PR', 'PRI', '630'),
  new CountryISOCode('QA', 'QAT', '634'),
  new CountryISOCode('RE', 'REU', '638'),
  new CountryISOCode('RO', 'ROU', '642'),
  new CountryISOCode('RU', 'RUS', '643'),
  new CountryISOCode('RW', 'RWA', '646'),
  new CountryISOCode('BL', 'BLM', '652'),
  new CountryISOCode('SH', 'SHN', '654'),
  new CountryISOCode('KN', 'KNA', '659'),
  new CountryISOCode('LC', 'LCA', '662'),
  new CountryISOCode('MF', 'MAF', '663'),
  new CountryISOCode('PM', 'SPM', '666'),
  new CountryISOCode('VC', 'VCT', '670'),
  new CountryISOCode('WS', 'WSM', '882'),
  new CountryISOCode('SM', 'SMR', '674'),
  new CountryISOCode('ST', 'STP', '678'),
  new CountryISOCode('SA', 'SAU', '682'),
  new CountryISOCode('SN', 'SEN', '686'),
  new CountryISOCode('RS', 'SRB', '688'),
  new CountryISOCode('SC', 'SYC', '690'),
  new CountryISOCode('SL', 'SLE', '694'),
  new CountryISOCode('SG', 'SGP', '702'),
  new CountryISOCode('SX', 'SXM', '534'),
  new CountryISOCode('SK', 'SVK', '703'),
  new CountryISOCode('SI', 'SVN', '705'),
  new CountryISOCode('SB', 'SLB', '090'),
  new CountryISOCode('SO', 'SOM', '706'),
  new CountryISOCode('ZA', 'ZAF', '710'),
  new CountryISOCode('GS', 'SGS', '239'),
  new CountryISOCode('SS', 'SSD', '728'),
  new CountryISOCode('ES', 'ESP', '724'),
  new CountryISOCode('LK', 'LKA', '144'),
  new CountryISOCode('SD', 'SDN', '729'),
  new CountryISOCode('SR', 'SUR', '740'),
  new CountryISOCode('SJ', 'SJM', '744'),
  new CountryISOCode('SE', 'SWE', '752'),
  new CountryISOCode('CH', 'CHE', '756'),
  new CountryISOCode('SY', 'SYR', '760'),
  new CountryISOCode('TW', 'TWN', '158'),
  new CountryISOCode('TJ', 'TJK', '762'),
  new CountryISOCode('TZ', 'TZA', '834'),
  new CountryISOCode('TH', 'THA', '764'),
  new CountryISOCode('TL', 'TLS', '626'),
  new CountryISOCode('TG', 'TGO', '768'),
  new CountryISOCode('TK', 'TKL', '772'),
  new CountryISOCode('TO', 'TON', '776'),
  new CountryISOCode('TT', 'TTO', '780'),
  new CountryISOCode('TN', 'TUN', '788'),
  new CountryISOCode('TR', 'TUR', '792'),
  new CountryISOCode('TM', 'TKM', '795'),
  new CountryISOCode('TC', 'TCA', '796'),
  new CountryISOCode('TV', 'TUV', '798'),
  new CountryISOCode('UG', 'UGA', '800'),
  new CountryISOCode('UA', 'UKR', '804'),
  new CountryISOCode('AE', 'ARE', '784'),
  new CountryISOCode('GB', 'GBR', '826'),
  new CountryISOCode('UM', 'UMI', '581'),
  new CountryISOCode('US', 'USA', '840'),
  new CountryISOCode('UY', 'URY', '858'),
  new CountryISOCode('UZ', 'UZB', '860'),
  new CountryISOCode('VU', 'VUT', '548'),
  new CountryISOCode('VE', 'VEN', '862'),
  new CountryISOCode('VN', 'VNM', '704'),
  new CountryISOCode('VG', 'VGB', '092'),
  new CountryISOCode('VI', 'VIR', '850'),
  new CountryISOCode('WF', 'WLF', '876'),
  new CountryISOCode('EH', 'ESH', '732'),
  new CountryISOCode('YE', 'YEM', '887'),
  new CountryISOCode('ZM', 'ZMB', '894'),
  new CountryISOCode('ZW', 'ZWE', '716')
]

export default CountryISOCode
